import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import set from 'lodash/set'
import unset from 'lodash/unset'
import now from 'lodash/now'
import generate from 'firebase-auto-ids'
import { getTemplateByApp } from 'templates/templates'


function replace (customStyles, oldClassName, newClassName) {
  const style = get(customStyles, oldClassName)
  if (style) {
    unset(customStyles, oldClassName)
    set(customStyles, newClassName, style)
  }
}

function addOutSideSlideIds (app) {
  console.log('addOutSideSlideIds', app.id)
  const slidesCnt = get(app, 'slidesCnt', 3)
  for (let num = 0; num < slidesCnt; num++) {
    // rename old clas names based on num to new based on slideId
    let slideId = get(app, ['customFields', 'showcases', num, 'slideId'])
    if (!slideId) {
      slideId = generate(now())
      set(app, ['customFields', 'showcases', num, 'slideId'], slideId)
    }
    const customStyles = get(app, 'customFields.customStyles')
    if (customStyles) {
      replace(customStyles, `ou_showcase_${num}_image_p`, `ou_showcase_${slideId}_image_p`)
      replace(customStyles, `ou_static-logo-showcase-p${num}`, `ou_static-logo-showcase-p${slideId}`)
      replace(customStyles, `ou_showcase_link_p${num * 2 + 1}`, `ou_showcase_link_p${slideId}_0`)
      replace(customStyles, `ou_showcase_link_p${num * 2 + 2}`, `ou_showcase_link_p${slideId}_1`)
    }

    // copy product links positions to the customFields
    const template = getTemplateByApp(app)
    const copyPaths = [
      ['showcases', num, 'products', 0, 'x'],
      ['showcases', num, 'products', 0, 'y'],
      ['showcases', num, 'products', 1, 'x'],
      ['showcases', num, 'products', 1, 'y']
    ]
    for (const path of copyPaths) {
      set(app.customFields, path, get(template.settings, path))
    }
  }
}

function migrateOutSideStyles (user) {
  console.log('migrateOutSideStyles')
  if (!isEmpty(user.apps)) {
    for (const appId in user.apps) {
      const app = user.apps[appId]
      if (app.templateId === 'outSide') {
        addOutSideSlideIds(app)
      }
    }
  }
}

const migrations = [
  migrateOutSideStyles
]

export default migrations



// WEBPACK FOOTER //
// ./src/controllers/migrations.js